let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("68mEC")).then(() => parcelRequire('17zIZ'));